import {
  MaterialVolume,
  LayerMaterials,
} from "../../../../../../smokepit/src/types/MaterialVolumes";

export function getMaterialColorHash(materialName: string): number {
  let hash = 5381;
  for (let i = 0; i < materialName.length; i++) {
    hash = (hash << 5) + hash + materialName.charCodeAt(i);
  }
  return hash;
}

/** Resolve a material record across site surveys for the active layer (single definition of the flatMap+find shape). */
export function findMaterialInSurveys(
  allSiteSurveysData: { layers?: LayerMaterials[] }[],
  selectedLayerLabel: string | null,
  materialId: number
): MaterialVolume | undefined {
  return allSiteSurveysData
    .flatMap((s) => {
      if (!s.layers) return [];
      const layer = s.layers.find(
        (l: LayerMaterials) => l.layer_label === selectedLayerLabel
      );
      return layer?.materials || [];
    })
    .find((m: MaterialVolume) => m.material_id === materialId);
}

export function buildMaterialColorMap(
  filteredMaterials: MaterialVolume[],
  allSiteSurveysData: { layers?: LayerMaterials[] }[],
  selectedLayerLabel: string | null,
  palette: string[]
): Map<number, string> {
  const map = new Map<number, string>();
  const usedColors = new Set<string>();

  const materialIdToName = new Map<number, string>();
  filteredMaterials.forEach((m: MaterialVolume) => {
    materialIdToName.set(m.material_id, m.name);
  });

  allSiteSurveysData.forEach((survey) => {
    if (survey.layers) {
      const layer = survey.layers.find(
        (layer: LayerMaterials) => layer.layer_label === selectedLayerLabel
      );
      layer?.materials?.forEach((m: MaterialVolume) => {
        if (!materialIdToName.has(m.material_id)) {
          materialIdToName.set(m.material_id, m.name);
        }
      });
    }
  });

  const sortedIds = Array.from(materialIdToName.keys()).sort((a, b) => a - b);

  sortedIds.forEach((materialId) => {
    const materialName = materialIdToName.get(materialId) || "Unknown";
    const hash = getMaterialColorHash(materialName);
    let colorIndex = Math.abs(hash) % palette.length;
    let color = palette[colorIndex];

    let attempts = 0;
    while (usedColors.has(color) && attempts < palette.length) {
      colorIndex = (colorIndex + 1) % palette.length;
      color = palette[colorIndex];
      attempts++;
    }

    map.set(materialId, color);
    usedColors.add(color);
  });

  return map;
}
